import { useState } from 'react'
import { type IntegrationServiceId } from '../../../common/integrations'
import { useAccountOpeningConnectors } from './useAccountOpeningConnectors'

interface ResolvedConnector {
  connectors: IntegrationServiceId[]
  connector: IntegrationServiceId | null
  setConnector: (connector: IntegrationServiceId) => void
}

export const useResolvedConnector = (seed?: IntegrationServiceId | null): ResolvedConnector => {
  const { connectors } = useAccountOpeningConnectors()
  const [chosen, setChosen] = useState<IntegrationServiceId | null>(null)

  return { connectors, connector: chosen ?? seed ?? connectors[0] ?? null, setConnector: setChosen }
}
